import type { Zahlung } from './api';

/** Eintrag aus GET /kassen/:id/zahlungen?seit= (jüngster Stand je Zahlung). */
export interface ZahlungMitBeleg {
  zahlung: Zahlung;
  belegnummer: string | null;
  /** Z-2: ohne Beleg vollständig bestätigt rückerstattet (fehlt bei älteren Servern). */
  vollstaendigErstattet?: boolean;
}

/**
 * „Zahlung prüfen“ ohne Vorgangs-ID (Altweg, verlorene Startantwort): Kandidaten sind laufende
 * oder bezahlte Zahlungen ohne Beleg. Z-2 (W5-A4): Eine ohne Beleg vollständig rückerstattete
 * Zahlung ist erledigt (der Zahlungsabgleich zählt sie ebenso nicht) und kein Kandidat mehr –
 * sonst entstünde der unnötige Hinweis „mehrere ungeklärte Kartenzahlungen“. Fehlt das Feld
 * (älterer Server), bleibt sie wie bisher ein Kandidat.
 */
export function zahlungsKandidaten<T extends ZahlungMitBeleg>(liste: readonly T[]): T[] {
  return liste.filter(
    (x) =>
      x.belegnummer === null &&
      x.vollstaendigErstattet !== true &&
      (x.zahlung.status === 'ausstehend' || x.zahlung.status === 'bezahlt'),
  );
}
